import { Component, OnInit, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { SettingsService } from '../../../data/repositories/settings/settings.service';
import { CommonNotificationService } from '../../services/common-notification/common-notification.service';
import { CustomValidator } from '../../_validators/custom-validator';
import { AppSelectorService } from '../../services/app-selector/app-selector.service';
import { TrialUserService } from 'src/app/shared/services/trial-user/trial-user.service';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';
import { some, forEach } from 'lodash';

@Component({
  selector: 'app-create-app',
  templateUrl: './create-app.component.html',
  styleUrls: ['./create-app.component.scss']
})
export class CreateAppComponent implements OnInit {
  public btnPromise: any;
  public createAppForm: any = FormGroup;
  public apps;
  public scopeData: any = {
    appTypes: [
      { 'name': 'Android', 'value': 'android', featureName: 'add_app_android', section: 'account_settings', parentFeature: 'apps', hidden: false },
      { 'name': 'iOS', 'value': 'ios', featureName: 'add_app_ios', parentFeature: 'apps', section: 'account_settings', hidden: false },
      { 'name': 'Web', 'value': 'web', featureName: 'add_app_web', parentFeature: 'apps', section: 'account_settings', hidden: false },
      { 'name': 'Server', 'value': 'be', featureName: 'add_app_server', parentFeature: 'apps', section: 'account_settings', hidden: false }
    ]
  };
  public trialUserData: any;
  constructor(private formBuilder: FormBuilder,
    private settingsService: SettingsService,
    private dialogRef: MatDialogRef<CreateAppComponent>,
    private commonNotificationService: CommonNotificationService,
    private appSelectorService: AppSelectorService,
    private trialUserService: TrialUserService,
    private featureListJsonService: FeatureListJsonService,
    private amplitudeLoggerService: AmplitudeLoggerService,
    private _elementRef: ElementRef) { }

  ngOnInit() {
    this.trialUserData = this.trialUserService.trialUserData;
    this.buildCreateAppForm();
    this.checkForHiddenApp();
    this.appSelectorService.getAppChangedListener().subscribe(() => {
      this.checkForHiddenApp();
    });
  }

  checkForHiddenApp() {
    this.scopeData.appTypes.forEach(app => {
      // tslint:disable-next-line: max-line-length
      this.featureListJsonService.shouldEnableTheFeature(`${app.section}.${app.parentFeature}.${app.featureName}`, 'hidden', (flag) => app.hidden = flag);
    });
  }

  buildCreateAppForm() {
    this.createAppForm = this.formBuilder.group({
      appName: [null, [Validators.required, CustomValidator.deepConfigNameValidator]],
      appType: [null, Validators.required],
      appDomain: [null, CustomValidator.domainValidator],
      appCustomUrl: [null, CustomValidator.customUrlValidator]
    });
  }

  showDomainField() {
    const appDetails = this.createAppForm.getRawValue();
    const show = appDetails['appType'] && appDetails['appType'] === 'web';
    // if (show) {
    //   this.createAppForm.get('appDomain').markAsDirty();
    // }
    return show;
  }

  showAppCustomUrlField() {
    const appDetails = this.createAppForm.getRawValue();
    const show = appDetails['appType'] && appDetails['appType'] === 'ios';
    return show;
  }

  isDuplicateApp(newAppName) {
    forEach(this.apps, appsArr => {
      const flag = some(appsArr, function (app) { return app.name === newAppName; });
      if (flag) {
        return true;
      }
    });
    return false;
  }

  isFormValid() {
    if (this.showDomainField()) {
      const domain = this.createAppForm.getRawValue()['appDomain'];
      return this.createAppForm.invalid || domain === undefined || domain === null ||
        CustomValidator.domainValidator(this.createAppForm.get('appDomain'));
    } else if (this.showAppCustomUrlField()) {
      const customUrl = this.createAppForm.getRawValue()['appCustomUrl'];
      return this.createAppForm.invalid || customUrl === undefined || customUrl === null ||
        CustomValidator.customUrlValidator(this.createAppForm.get('appCustomUrl'));
    } else {
      return this.createAppForm.invalid;
    }
  }

  logAppCreation() {
    const { appName, platform, domain } = this.createAppForm.value;
    const { eventName: { APPS_CREATE }, eventAction: { CREATE_SUBMIT } } = AnalyticsEvents;
    this.amplitudeLoggerService.log(APPS_CREATE, CREATE_SUBMIT, {
      app_name: appName,
      platform: platform,
      domain: domain
    });
  }

  onCreateAppSubmit() {
    const { appName, platform, domain, appCustomUrl } = this.createAppForm.value;
    this.apps = [];
    this.apps.push(this.appSelectorService.getApplist('production'));
    this.apps.push(this.appSelectorService.getApplist('stage'));
    if (this.isDuplicateApp(appName)) {
      this.commonNotificationService.showSnackBar(appName + ' already exists!', 'error', 2000);
      return;
    }
    const companyDetails: any = this.appSelectorService.getCompanyDetails();
    this.logAppCreation();
    this.btnPromise = this.settingsService.createApp(this.createAppForm.value, companyDetails.id).subscribe((response: any) => {
      if (response.is_error) {
        this.commonNotificationService.showSnackBar(' Failed to create app. Please try again !', 'error', 2000);
        this.dialogRef.close();
      } else {
        this.appSelectorService.loadAppsDetailsCount();
        this.commonNotificationService.showSnackBar(this.createAppForm.value.appName + ' app is created !', 'success', 2000);
        this.dialogRef.close(response);
      }
    });
  }

}
